// extracted by mini-css-extract-plugin
module.exports = {"logotype":"_3UaHOZ"};